import PropTypes from 'prop-types'
import React from 'react'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './ThreeDotsLoader.scss'
const rootClassName = 'loader-three-dots'

export const ThreeDotsLoader = (props) => {
  return (
    <div
      className={getMergedClassNames([
        rootClassName,
        `${rootClassName}-${props.theme}`,
        `${rootClassName}-size-${props.size}`
      ])}
      style={props.style}
    >
      <div />
      <div />
      <div />
    </div>
  )
}

ThreeDotsLoader.propTypes = {
  theme: PropTypes.oneOf(['primary', 'secondary', 'dark']),
  size: PropTypes.oneOf([1, 2, 3, 4])
}

ThreeDotsLoader.defaultProps = {
  theme: 'primary',
  size: 3
}
